"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CategoryOptions = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _header = _interopRequireDefault(require("../header"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _AccordionPanel = _interopRequireDefault(require("../panel/AccordionPanel"));

var _CloseInactiveTopicsPanel = require("./CloseInactiveTopicsPanel");

var _axios = _interopRequireDefault(require("axios"));

var _Loader = _interopRequireDefault(require("../ui-components/Loader"));

var _NotifyToMarkAnswerPanel = require("./NotifyToMarkAnswerPanel");

var _buttonControl = _interopRequireDefault(require("../../preact-components/button-control"));

var _reactModal = _interopRequireDefault(require("../../components/reactModal"));

var _categoryService = require("@insided/control/modules/Categories/categoryService");

var _categories = require("@insided/shared/utils/categories");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CategoryOptions = {
  ALL: 'All categories',
  CUSTOM: 'Custom - pick your own categories'
};
exports.CategoryOptions = CategoryOptions;

var AutomationRules = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AutomationRules, _Component);

  var _super = _createSuper(AutomationRules);

  function AutomationRules() {
    var _this$props$selectedC;

    var _this;

    (0, _classCallCheck2.default)(this, AutomationRules);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      storedState: {
        closeInactiveTopicsEnabled: _this.props.closeInactiveTopicsEnabled,
        selectedCategoryList: _this.props.selectedCategoryList,
        closeTopicsAfter: _this.props.closeTopicsAfter === 0 ? undefined : _this.props.closeTopicsAfter,
        notifyMarkAnswerEnabled: _this.props.notifyMarkAnswerEnabled,
        notifyAfter: _this.props.notifyAfter === 0 ? undefined : _this.props.notifyAfter
      },
      isCloseInactiveTopicsEnabled: _this.props.closeInactiveTopicsEnabled,
      closeTopicsIn: _this.props.closeTopicsAfter === 0 ? undefined : _this.props.closeTopicsAfter,
      selectedCategories: _this.props.selectedCategoryList,
      showCloseInactiveTopicsActionButtons: false,
      showCategoryDropdown: false,
      showValidationError: false,
      hasUnsavedChanges: false,
      showUnsavedChangesModal: false,
      isLoading: false,
      isNotifyMarkAnswerEnabled: _this.props.notifyMarkAnswerEnabled,
      notifyAfter: _this.props.notifyAfter === 0 ? undefined : _this.props.notifyAfter,
      showNotifyMarkAnswerActionButtons: false,
      showNotifyMarkAnswerValidationError: false,
      categoriesV2: {},
      selectedOption: ((_this$props$selectedC = _this.props.selectedCategoryList) === null || _this$props$selectedC === void 0 ? void 0 : _this$props$selectedC.length) === 0 ? CategoryOptions.ALL : CategoryOptions.CUSTOM
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var categoriesV2;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              window.addEventListener('beforeunload', function (e) {
                return _this.onUnload(e);
              });
              _context.next = 3;
              return (0, _categoryService.getCategoriesList)([(0, _categories.getTypeFromModuleName)(_categories.MODULE.COMMUNITY), (0, _categories.getTypeFromModuleName)(_categories.MODULE.KNOWLEDGE_BASE), (0, _categories.getTypeFromModuleName)(_categories.MODULE.GROUPS)]);

            case 3:
              categoriesV2 = _context.sent;

              _this.setState({
                categoriesV2: categoriesV2
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentWillUnmount", function () {
      window.removeEventListener('beforeunload', _this.onUnload);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUnload", function (e) {
      if (_this.checkPanelHasUnsavedChanges()) {
        e.preventDefault();
        e.returnValue = '';
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveCloseInactiveTopicsRule", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _this$state, closeTopicsIn, isCloseInactiveTopicsEnabled, selectedOption, selectedCategories, invalidInputForCloseTopicsIn, successMessage, errorMessage, _this$state$closeTopi;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state = _this.state, closeTopicsIn = _this$state.closeTopicsIn, isCloseInactiveTopicsEnabled = _this$state.isCloseInactiveTopicsEnabled, selectedOption = _this$state.selectedOption, selectedCategories = _this$state.selectedCategories;
              invalidInputForCloseTopicsIn = closeTopicsIn === undefined || closeTopicsIn === null || closeTopicsIn <= 0 || selectedOption === CategoryOptions.CUSTOM && selectedCategories.length === 0;

              if (!(invalidInputForCloseTopicsIn && isCloseInactiveTopicsEnabled)) {
                _context2.next = 5;
                break;
              }

              _this.setState({
                showValidationError: true
              });

              return _context2.abrupt("return");

            case 5:
              _this.setState({
                messageType: null,
                isLoading: true
              });

              successMessage = "'Automatically close inactive topics' settings have been updated successfully.";
              errorMessage = "Something went wrong, settings can't be updated. Please try again.";
              _context2.prev = 8;
              _context2.next = 11;
              return _axios.default.post('/settings/automationRules/closeInactiveTopicsSetting', {
                isCloseInactiveTopicsEnabled: _this.state.isCloseInactiveTopicsEnabled,
                closeTopicsAfterDays: (_this$state$closeTopi = _this.state.closeTopicsIn) !== null && _this$state$closeTopi !== void 0 ? _this$state$closeTopi : 0,
                selectedCategories: _this.state.selectedCategories
              });

            case 11:
              _this.setState(function (prevState) {
                return {
                  isLoading: false,
                  storedState: _objectSpread(_objectSpread({}, prevState.storedState), {}, {
                    closeTopicsAfter: prevState.closeTopicsIn,
                    selectedCategoryList: prevState.selectedCategories,
                    closeInactiveTopicsEnabled: prevState.isCloseInactiveTopicsEnabled,
                    selectedOption: prevState.selectedOption
                  }),
                  message: successMessage,
                  messageType: 'success',
                  showCloseInactiveTopicsActionButtons: false,
                  activePanel: 1
                };
              });

              _context2.next = 18;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](8);

              _logger.logger.error(_context2.t0, {
                component: 'AutomationRules',
                action: 'saveCloseInactiveTopics'
              });

              _this.setState({
                isLoading: false,
                messageType: 'error',
                message: errorMessage,
                showCloseInactiveTopicsActionButtons: false,
                activePanel: 1
              });

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 14]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetCloseInactiveTopicsSetting", function () {
      var _this$state$storedSta = _this.state.storedState,
          closeInactiveTopicsEnabled = _this$state$storedSta.closeInactiveTopicsEnabled,
          closeTopicsAfter = _this$state$storedSta.closeTopicsAfter,
          selectedCategoryList = _this$state$storedSta.selectedCategoryList;

      _this.setState({
        isCloseInactiveTopicsEnabled: closeInactiveTopicsEnabled,
        closeTopicsIn: closeTopicsAfter,
        selectedCategories: selectedCategoryList,
        showCloseInactiveTopicsActionButtons: false,
        showValidationError: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCloseInactiveTopicsSettingChanged", function (value) {
      if (!value) {
        _this.setState({
          showValidationError: false
        });
      }

      _this.setState(function (prevState) {
        var _prevState$storedStat = prevState.storedState,
            closeInactiveTopicsEnabled = _prevState$storedStat.closeInactiveTopicsEnabled,
            closeTopicsAfter = _prevState$storedStat.closeTopicsAfter,
            selectedCategoryList = _prevState$storedStat.selectedCategoryList;
        var closeTopicsIn = prevState.closeTopicsIn,
            selectedCategories = prevState.selectedCategories;
        var showActionButtons = closeInactiveTopicsEnabled !== value || closeTopicsAfter !== closeTopicsIn || selectedCategoryList !== selectedCategories;
        return {
          isCloseInactiveTopicsEnabled: value,
          showCloseInactiveTopicsActionButtons: showActionButtons,
          showCategoryDropdown: false,
          hasUnsavedChanges: showActionButtons,
          activePanel: 1
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInputChange", function (value) {
      if (isNaN(value) || value <= 0) {
        _this.setState({
          closeTopicsIn: undefined,
          showValidationError: true,
          hasUnsavedChanges: true,
          showCloseInactiveTopicsActionButtons: true,
          activePanel: 1
        });

        return;
      }

      _this.setState(function (prevState) {
        var showActionButtons = prevState.storedState.closeTopicsAfter !== value;
        return {
          closeTopicsIn: value,
          showCloseInactiveTopicsActionButtons: showActionButtons,
          hasUnsavedChanges: showActionButtons,
          showValidationError: false,
          activePanel: 1
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInputFocus", function () {
      _this.setState({
        showCloseInactiveTopicsActionButtons: true,
        showValidationError: false,
        showCategoryDropdown: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInputBlur", function () {
      var showActionButtons = _this.isCloseInactiveTopicRuleUpdated();

      _this.setState({
        showCloseInactiveTopicsActionButtons: showActionButtons
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleCategoryDropdown", function (isCategoryDropdownVisible) {
      var showActionButtons = false;

      if (!isCategoryDropdownVisible) {
        showActionButtons = _this.isCloseInactiveTopicRuleUpdated();
      }

      _this.setState({
        showCategoryDropdown: isCategoryDropdownVisible,
        showCloseInactiveTopicsActionButtons: showActionButtons
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectedCategoriesChanged", function (id, data) {
      _this.setState(function (prevState) {
        var showActionButtons = prevState.storedState.selectedCategoryList !== data;
        return {
          selectedCategories: data,
          showCloseInactiveTopicsActionButtons: showActionButtons,
          hasUnsavedChanges: showActionButtons,
          showCategoryDropdown: false
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetCategories", function () {
      var showActionButtons = _this.isCloseInactiveTopicRuleUpdated();

      _this.setState({
        showCategoryDropdown: false,
        showCloseInactiveTopicsActionButtons: showActionButtons
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isCloseInactiveTopicRuleUpdated", function () {
      var _this$state$storedSta2 = _this.state.storedState,
          closeInactiveTopicsEnabled = _this$state$storedSta2.closeInactiveTopicsEnabled,
          closeTopicsAfter = _this$state$storedSta2.closeTopicsAfter,
          selectedCategoryList = _this$state$storedSta2.selectedCategoryList;
      return closeInactiveTopicsEnabled !== _this.state.isCloseInactiveTopicsEnabled || closeTopicsAfter !== _this.state.closeTopicsIn || selectedCategoryList !== _this.state.selectedCategories;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNotifyAfterInputChange", function (value) {
      if (isNaN(value) || value <= 0) {
        _this.setState({
          notifyAfter: undefined,
          showNotifyMarkAnswerValidationError: true,
          hasUnsavedChanges: true,
          showNotifyMarkAnswerActionButtons: true,
          activePanel: 0
        });

        return;
      }

      _this.setState(function (prevState) {
        var showActionButtons = prevState.storedState.notifyAfter !== value;
        return {
          notifyAfter: value,
          showNotifyMarkAnswerActionButtons: showActionButtons,
          hasUnsavedChanges: showActionButtons,
          showNotifyMarkAnswerValidationError: false,
          activePanel: 0
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNotifyAfterInputFocus", function () {
      _this.setState({
        showNotifyMarkAnswerActionButtons: true,
        showNotifyMarkAnswerValidationError: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNotifyAfterInputBlur", function () {
      var showActionButtons = _this.isNotifyMarkAnswerRuleUpdated();

      _this.setState({
        showNotifyMarkAnswerActionButtons: showActionButtons
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetNotifyMarkAnswerSetting", function () {
      var _this$state$storedSta3 = _this.state.storedState,
          notifyMarkAnswerEnabled = _this$state$storedSta3.notifyMarkAnswerEnabled,
          notifyAfter = _this$state$storedSta3.notifyAfter;

      _this.setState({
        isNotifyMarkAnswerEnabled: notifyMarkAnswerEnabled,
        notifyAfter: notifyAfter,
        showNotifyMarkAnswerActionButtons: false,
        showNotifyMarkAnswerValidationError: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveNotifyMarkAnswerRule", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _this$state2, notifyAfter, isNotifyMarkAnswerEnabled, invalidInputForNotifyAfter, successMessage, errorMessage, _this$state$notifyAft;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$state2 = _this.state, notifyAfter = _this$state2.notifyAfter, isNotifyMarkAnswerEnabled = _this$state2.isNotifyMarkAnswerEnabled;
              invalidInputForNotifyAfter = notifyAfter === undefined || notifyAfter === null || notifyAfter <= 0;

              if (!(invalidInputForNotifyAfter && isNotifyMarkAnswerEnabled)) {
                _context3.next = 5;
                break;
              }

              _this.setState({
                showNotifyMarkAnswerValidationError: true
              });

              return _context3.abrupt("return");

            case 5:
              _this.setState({
                messageType: null,
                isLoading: true
              });

              successMessage = "'Ask end users to mark best answer via email' settings have been updated successfully.";
              errorMessage = "Something went wrong, settings can't be updated. Please try again.";
              _context3.prev = 8;
              _context3.next = 11;
              return _axios.default.post('/settings/automationRules/notifyMarkAnswerSetting', {
                isNotifyMarkAnswerEnabled: _this.state.isNotifyMarkAnswerEnabled,
                notifyAfter: (_this$state$notifyAft = _this.state.notifyAfter) !== null && _this$state$notifyAft !== void 0 ? _this$state$notifyAft : 0
              });

            case 11:
              _this.setState(function (prevState) {
                return {
                  isLoading: false,
                  storedState: _objectSpread(_objectSpread({}, prevState.storedState), {}, {
                    notifyAfter: prevState.notifyAfter,
                    notifyMarkAnswerEnabled: prevState.isNotifyMarkAnswerEnabled
                  }),
                  message: successMessage,
                  messageType: 'success',
                  showNotifyMarkAnswerActionButtons: false
                };
              });

              _context3.next = 18;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](8);

              _logger.logger.error(_context3.t0, {
                component: 'AutomationRules',
                action: 'saveNotifyMarkAnswer'
              });

              _this.setState({
                isLoading: false,
                messageType: 'error',
                message: errorMessage,
                showNotifyMarkAnswerActionButtons: false
              });

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[8, 14]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNotifyMarkAnswerSettingChanged", function (value) {
      if (!value) {
        _this.setState({
          showNotifyMarkAnswerValidationError: false
        });
      }

      _this.setState(function (prevState) {
        var _prevState$storedStat2 = prevState.storedState,
            notifyMarkAnswerEnabled = _prevState$storedStat2.notifyMarkAnswerEnabled,
            notifyAfter = _prevState$storedStat2.notifyAfter;
        var showActionButtons = notifyMarkAnswerEnabled !== value || notifyAfter !== prevState.closeTopicsIn;
        return {
          isNotifyMarkAnswerEnabled: value,
          showNotifyMarkAnswerActionButtons: showActionButtons,
          hasUnsavedChanges: showActionButtons,
          activePanel: 0
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isNotifyMarkAnswerRuleUpdated", function () {
      var _this$state$storedSta4 = _this.state.storedState,
          notifyMarkAnswerEnabled = _this$state$storedSta4.notifyMarkAnswerEnabled,
          notifyAfter = _this$state$storedSta4.notifyAfter;
      return notifyMarkAnswerEnabled !== _this.state.isNotifyMarkAnswerEnabled || notifyAfter !== _this.state.notifyAfter;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeModal", function () {
      _this.setState({
        showUnsavedChangesModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkPanelHasUnsavedChanges", function () {
      var hasUnsavedChanges = _this.state.hasUnsavedChanges;
      return _this.isNotifyMarkAnswerRuleUpdated() || _this.isCloseInactiveTopicRuleUpdated() || hasUnsavedChanges;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetChanges", function () {
      var hasCloseInactiveTopicsRuleUpdated = _this.isCloseInactiveTopicRuleUpdated();

      var hasNotifyMarkAnswerRuleUpdated = _this.isNotifyMarkAnswerRuleUpdated();

      if (hasNotifyMarkAnswerRuleUpdated) {
        _this.setState({
          activePanel: 1
        });

        _this.resetNotifyMarkAnswerSetting();
      }

      if (hasCloseInactiveTopicsRuleUpdated) {
        _this.setState({
          activePanel: 0
        });

        _this.resetCloseInactiveTopicsSetting();

        _this.onResetCategories();
      }

      _this.setState({
        hasUnsavedChanges: false,
        showUnsavedChangesModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOptionChange", function (key, categoryDropdownId) {
      var selectedCategories = _this.state.selectedCategories;

      _this.setState({
        selectedOption: key
      });

      if (key === CategoryOptions.ALL) {
        _this.onSelectedCategoriesChanged(categoryDropdownId, []);

        return;
      }

      if (selectedCategories) {
        _this.onSelectedCategoriesChanged(categoryDropdownId, selectedCategories);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(AutomationRules, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state3 = this.state,
          storedState = _this$state3.storedState,
          selectedCategories = _this$state3.selectedCategories,
          closeTopicsIn = _this$state3.closeTopicsIn,
          isCloseInactiveTopicsEnabled = _this$state3.isCloseInactiveTopicsEnabled,
          showCloseInactiveTopicsActionButtons = _this$state3.showCloseInactiveTopicsActionButtons,
          showValidationError = _this$state3.showValidationError,
          message = _this$state3.message,
          messageType = _this$state3.messageType,
          showUnsavedChangesModal = _this$state3.showUnsavedChangesModal,
          showCategoryDropdown = _this$state3.showCategoryDropdown,
          isLoading = _this$state3.isLoading,
          isNotifyMarkAnswerEnabled = _this$state3.isNotifyMarkAnswerEnabled,
          notifyAfter = _this$state3.notifyAfter,
          showNotifyMarkAnswerActionButtons = _this$state3.showNotifyMarkAnswerActionButtons,
          showNotifyMarkAnswerValidationError = _this$state3.showNotifyMarkAnswerValidationError,
          activePanel = _this$state3.activePanel,
          categoriesV2 = _this$state3.categoriesV2,
          selectedOption = _this$state3.selectedOption;
      var isVisibleFor = messageType === 'success' ? 5000 : false;
      var closeInactiveTopicsStatusText = storedState.closeInactiveTopicsEnabled ? 'on' : 'off';
      var notifyMarkAnswerStatusText = storedState.notifyMarkAnswerEnabled ? 'on' : 'off';
      var categoryDropdownId = 'categoryDropdownFilter';
      var panelHasUnsavedChanges = this.checkPanelHasUnsavedChanges();
      var CloseInactiveTopicsPanel = {
        title: (0, _preact.h)(_CloseInactiveTopicsPanel.CloseInactiveTopicsPanelHeader, {
          statusText: closeInactiveTopicsStatusText
        }),
        body: (0, _preact.h)(_CloseInactiveTopicsPanel.CloseInactiveTopicsPanelBody, {
          isCloseInactiveTopicsEnabled: isCloseInactiveTopicsEnabled,
          selectedCategories: selectedCategories,
          categoriesV2: categoriesV2,
          closeTopicsIn: closeTopicsIn,
          showCategoryDropdown: showCategoryDropdown,
          showActionButtons: showCloseInactiveTopicsActionButtons,
          showValidationError: showValidationError,
          onSave: this.saveCloseInactiveTopicsRule,
          onCancel: this.resetCloseInactiveTopicsSetting,
          onResetCategories: this.onResetCategories,
          onSelectedCategoriesChanged: function onSelectedCategoriesChanged(categoryDropdownId, selectedCategories) {
            return _this2.onSelectedCategoriesChanged(categoryDropdownId, selectedCategories);
          },
          categoryDropdownId: categoryDropdownId,
          onInputChange: function onInputChange(value) {
            return _this2.onInputChange(parseInt(value));
          },
          onInputFocus: this.onInputFocus,
          onInputBlur: this.onInputBlur,
          toggleCategoryDropdown: function toggleCategoryDropdown() {
            return _this2.toggleCategoryDropdown(!showCategoryDropdown);
          },
          onCloseInactiveTopicsSettingChanged: function onCloseInactiveTopicsSettingChanged() {
            return _this2.onCloseInactiveTopicsSettingChanged(!isCloseInactiveTopicsEnabled);
          },
          selectedOption: selectedOption,
          handleOptionChange: this.handleOptionChange
        }),
        hasUnsavedChanges: panelHasUnsavedChanges,
        customClass: 'panel-with-dropdown-in-body'
      };
      var NotifyMarkAnswerPanel = {
        title: (0, _preact.h)(_NotifyToMarkAnswerPanel.NotifyToMarkAnswerPanelHeader, {
          statusText: notifyMarkAnswerStatusText
        }),
        body: (0, _preact.h)(_NotifyToMarkAnswerPanel.NotifyToMarkAnswerPanelBody, {
          isNotifyMarkAnswerEnabled: isNotifyMarkAnswerEnabled,
          notifyAfter: notifyAfter,
          showActionButtons: showNotifyMarkAnswerActionButtons,
          showValidationError: showNotifyMarkAnswerValidationError,
          onSave: this.saveNotifyMarkAnswerRule,
          onCancel: this.resetNotifyMarkAnswerSetting,
          onInputChange: function onInputChange(value) {
            return _this2.onNotifyAfterInputChange(parseInt(value));
          },
          onInputFocus: this.onNotifyAfterInputFocus,
          onInputBlur: this.onNotifyAfterInputBlur,
          onNotifyMarkAnswerSettingChanged: function onNotifyMarkAnswerSettingChanged() {
            return _this2.onNotifyMarkAnswerSettingChanged(!isNotifyMarkAnswerEnabled);
          }
        }),
        hasUnsavedChanges: panelHasUnsavedChanges
      };
      return (0, _preact.h)("div", {
        className: "automation-rules-overview qa-automation-rules-overview"
      }, (0, _preact.h)(_header.default, {
        title: "Automation Rules",
        disableCancelButton: true,
        disableSaveButton: true
      }), isLoading && (0, _preact.h)(_Loader.default, null), messageType ? (0, _preact.h)(_AlertComponent.default, {
        messageType: messageType,
        message: message,
        sticky: true,
        renderHTML: true,
        isVisibleFor: isVisibleFor
      }) : null, (0, _preact.h)(_AccordionPanel.default, {
        defaultActivePanelIndex: activePanel,
        panels: [NotifyMarkAnswerPanel, CloseInactiveTopicsPanel],
        renderUnsavedChangesModal: function renderUnsavedChangesModal() {
          return _this2.setState({
            showUnsavedChangesModal: true
          });
        }
      }), (0, _preact.h)(_reactModal.default, {
        isOpen: showUnsavedChangesModal,
        onClose: this.closeModal
      }, (0, _preact.h)("div", {
        className: "unsaved-changes-modal"
      }, (0, _preact.h)("h3", {
        className: "modal-title"
      }, "Unsaved Changes"), (0, _preact.h)("div", {
        className: "modal-description"
      }, "You have unsaved changes. Do you want to discard them?"), (0, _preact.h)(_buttonControl.default, {
        size: "medium",
        variant: "brand",
        newStyle: true,
        title: "Discard changes",
        onClick: this.resetChanges
      }), (0, _preact.h)(_buttonControl.default, {
        newStyle: true,
        size: "medium",
        title: "Cancel",
        onClick: this.closeModal
      }))));
    }
  }]);
  return AutomationRules;
}(_preact.Component);

var _default = AutomationRules;
exports.default = _default;